import React, { useState } from 'react'

const Project = ({image, url,id}) => {
    const [hovered, setHovered] = useState(false)
  return (
    <a
    onMouseEnter={() => setHovered(true)}
    onMouseLeave={() => setHovered(false)}

     href={url} target='_blank' className='w-full h-full rounded shadow-2xl drop-shadow-xl shadow-gray-600'>
        <img src={image} alt={id}  className='rounded object-cover h-full w-full'/>
        {hovered &&
        <div className="absolute inset-0 bg-black bg-opacity-75 text-white hover:bg-opacity-80 transition duration-300">
            <div className="flex flex-row justify-center items-center px-1 h-full">
              <button className="border border-teal-400 text-center px-3 py-2 rounded-sm"> Visit project</button>
            </div>
          </div>}
    </a>
  )
}

export default Project